// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"143":"d2330484","217":"e05152c7","245":"65ac9df1","347":"992b1c03","423":"d05887a4","583":"0827dc07","688":"8a496702","711":"22f3a3af","880":"c32d8a3d","927":"6e767a3c"}[chunkId] + ".chunk.js";
};